<template>
    <div
        class="card g-card border-top-0 border-right-0 border-bottom-0 border-primary rounded-0 bg-light"
    >
        <div class="row pb-3 pt-3">
            <div class="col-auto-custom">
                <div class="g-product-info g-product-info-horizontal">
                    <div class="g-punched g-image-48">
                        <div class="g-punched g-image-20 text-success customCheck">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                focusable="false"
                                aria-hidden="true"
                            >
                                <defs>
                                    <rect id="checkbox_icon-a" width="16" height="16" rx="2" />
                                    <path
                                        id="checkbox_icon-b"
                                        d="M8.51705469,2.06002344 L3.71338281,6.86369531 L1.48299219,4.63338281 C1.28666406,4.43713281 0.968460938,4.43713281 0.772210938,4.63338281 C0.575960938,4.82963281 0.575960938,5.14791406 0.772210938,5.34408594 L3.29674219,7.86861719 C3.31361719,7.89307031 3.32385156,7.92049219 3.34557031,7.94221094 C3.44689844,8.04353906 3.58049219,8.09033594 3.71330469,8.08705469 C3.84603906,8.09033594 3.97971094,8.04361719 4.08111719,7.94228906 C4.10283594,7.92049219 4.11307031,7.89291406 4.13010156,7.86853906 L9.22775781,2.77080469 C9.42408594,2.57447656 9.42408594,2.25627344 9.22775781,2.06002344 C9.03150781,1.86369531 8.71330469,1.86369531 8.51705469,2.06002344"
                                    />
                                </defs>
                                <g fill="none" fill-rule="evenodd">
                                    <use fill="#5CB85C" xlink:href="#checkbox_icon-a" />
                                    <g transform="translate(3.316 3)">
                                        <mask id="checkbox_icon-c" fill="#fff">
                                            <use xlink:href="#checkbox_icon-b" />
                                        </mask>
                                        <use fill="#FFF" xlink:href="#checkbox_icon-b" />
                                        <g fill="#FFF" mask="url(#checkbox_icon-c)">
                                            <polygon points="0 0 10 0 10 10 0 10" />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="g-punched-content">
                            <svg class="ico-money g-punched-icon" aria-hidden="true" focusable="false">
                                <use href="#ico-money" xlink:href="#ico-money" />
                            </svg>
                        </div>
                    </div>
                    <div class="g-product-info-data">
                        <p class="g-major pb-1">
                            {{ signData.userAccountName }}
                            <br aria-hidden="true" />
                            <svg
                                style="display: inline-block;"
                                class="ico-arrow-right g-image-20 arrow"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <use xlink:href="#ico-arrow-right" />
                            </svg>
                            {{ signData.merchantAccountName }}
                        </p>
                        <p class="g-micro g-faded pb-smalltext">
                            {{ $t("sign.ibanPrefix") }}:
                            <span class="custom-a11y__wrapper">
                                <span class="custom-a11y__label" :aria-label="$helpers.splitStringForScreanReader(signData.userIban)"></span>
                                <span aria-hidden="true">
                                    {{
                                        $helpers.ibanReadability(
                                            signData.userIban
                                        )
                                    }}
                                </span>
                            </span>
                        </p>
                        <div v-for="(msg, key) in signData.recipientMessages" v-bind:key="key">
                            <p v-if="msg !== ''" class="g-micro g-faded pb-smalltext">
                                {{
                                $t("sign.textPrefix") + key.slice(-1) }}: {{ msg }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="pricetag color-george font-weight-bold"
            >{{ signData.amountToPay }} {{ signData.currency }}</div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'SignStripe',

        props: {
            signData: Object
        }
    };

</script>
